module.exports = __webpack_public_path__ + "img/50_44.331dda7a.png";